/* eslint-disable no-console */

// import { register } from 'register-service-worker'
const base = process.env.VUE_APP_BASE_URI || '/'
const swPath = `${base}/service-worker.js`

if (process.env.NODE_ENV === 'production') {
   // register(`${process.env.BASE_URL}service-worker.js`, {
   //    ready() {
   //       console.log(
   //          'App is being served from cache by a service worker.\n' +
   //          'For more details, visit https://goo.gl/AFskqB'
   //       )
   //    },
   //    registered() {
   //       console.log('Service worker has been registered.')
   //    },
   //    cached() {
   //       console.log('Content has been cached for offline use.')
   //    },
   //    updatefound() {
   //       console.log('New content is downloading.')
   //    },
   //    updated() {
   //       console.log('New content is available; please refresh.')
   //    },
   //    offline() {
   //       console.log('No internet connection found. App is running in offline mode.')
   //    },
   //    error(error) {
   //       console.error('Error during service worker registration:', error)
   //    }
   // })
   if ('serviceWorker' in navigator) {
   
      window.addEventListener('load', () => {
         navigator.serviceWorker.register(swPath)
            .then(() => console.log('SW registered'))
            .catch(err => console.error('SW registration failed:', err))
      })
   }

} else {
   if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
         navigator.serviceWorker.register(swPath)
            .then(() => console.log('SW registered'))
            .catch(err => console.error('SW registration failed:', err))
      })
   }
}
